import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { AuthService } from "~modules/auth/auth.service";
import { CQDictionaryComponent } from "~modules/mattress-foam/components/cq-dictionary/cq-dictionary.component";

@Component({
  selector: "cq-header",
  standalone: true,
  templateUrl: "./cq-header.component.html",
  styleUrl: "./cq-header.component.scss",
  imports: [CQDictionaryComponent, CommonModule],
  animations: [
    trigger("slideInOut", [
      state(
        "in",
        style({
          transform: "translateX(0)",
        }),
      ),
      state(
        "out",
        style({
          transform: "translateX(100%)",
        }),
      ),
      transition("in => out", animate("200ms ease-in-out")),
      transition("out => in", animate("200ms ease-in-out")),
    ]),
  ],
})
export class CQHeaderComponent implements OnInit {
  isDictionDisplayed: boolean = false;
  isLogin: boolean = false;

  constructor(private authService: AuthService) {}

  async ngOnInit(): Promise<void> {
    this.isLogin = await this.authService.isAuthenticated();
  }

  openDictionary(): void {
    this.isDictionDisplayed = this.isLogin ? !this.isDictionDisplayed : false;
  }
}
